import { useContext, useMemo } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { SplitioContext, SplitioFeature } from 'components/SplitioContext';
import { UserSessionContext } from 'components/UserSession';
import { EventDatetimeContext } from 'components/EventDatetime';
import useTwilioDesktop from 'components/twilio/hooks/useTwilioDesktop';

const useEnableExhibitorPanelTreatment = () => {
  const { isReady, isTreatmentOn } = useContext(SplitioContext);
  const { isDesktop } = useTwilioDesktop();

  const {
    customAttendeeFields: { vexpo_exhibitor_booth_id: vexpoExhibitorBoothId = '' } = {},
  } = useContext(UserSessionContext).userSession || {};
  const { isEventLive } = useContext(EventDatetimeContext);

  return useMemo(
    () => isReady
      && isTreatmentOn(SplitioFeature.enableExhibitorPanel)
      && isDesktop
      && vexpoExhibitorBoothId
      && isEventLive,
    [
      isReady,
      isTreatmentOn,
      isDesktop,
      vexpoExhibitorBoothId,
      isEventLive,
    ],
  );
};

export default useEnableExhibitorPanelTreatment;
